import { i18nFilter } from "app/filters/i18nFilter";
import { DefaultCellHookTypeWebsite, GroupTrafficShare, IndexCell, TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";

const DEFAULT_SORT_FIELD = "Share";
const DEFAULT_SORT_FIELD_COMPARE = "TotalShare";
const DEFAULT_SORT_DIRECTION = "desc";
const i18n = i18nFilter();

export const MonetizationNetworksSingleTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    getColumns: (sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION }) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: DefaultCellHeader,
                disableHeaderCellHover: true,
                sortable: false,
                width: 45,
                visible: true,
            },
            {
                field: "Name",
                cellComponent: DefaultCellHookTypeWebsite,
                displayName: i18n("analysis.source.ad.networks.table.columns.network.title"),
                groupable: true,
                sortable: true,
                showTotalCount: true,
            },
            {
                field: "Share",
                displayName: i18nFilter()("analysis.destination.paidout.trafficShare"),
                type: "double",
                sortable: true,
                cellComponent: TrafficShare,
                headerComponent: DefaultCellHeader,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                isResizable: col.isResizable !== false,
                visible: true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};

export const MonetizationNetworksCompareTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD_COMPARE,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    getColumns: (sortedColumn = { field: DEFAULT_SORT_FIELD_COMPARE, sortDirection: DEFAULT_SORT_DIRECTION }) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: DefaultCellHeader,
                disableHeaderCellHover: true,
                sortable: false,
                width: 45,
                visible: true,
            },
            {
                field: "Name",
                cellComponent: DefaultCellHookTypeWebsite,
                displayName: i18n("analysis.source.ad.networks.table.columns.network.title"),
                sortable: true,
                showTotalCount: true,
            },
            {
                field: "TotalShare",
                displayName: i18nFilter()("analysis.source.search.all.table.columns.totalShareCompare.title"),
                tooltip: i18nFilter()("analysis.advertisers.table.columns.totalShareCompare.title.tooltip"),
                type: "double",
                sortable: true,
                cellComponent: TrafficShare,
                headerComponent: DefaultCellHeader,
            },
            {
                field: "SiteOrigins",
                displayName: i18nFilter()("analysis.source.search.all.table.columns.shareCompare.title"),
                cellComponent: GroupTrafficShare,
                headerComponent: DefaultCellHeader,
                sortable: false,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                isResizable: col.isResizable !== false,
                visible: true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};
